const store = {
  namespaced: true,
  state: () => ({
    run: false,
    serveTime: Date.now(),
    clientTime: Date.now(),
    nowTime: Date.now()
  }),
  getters: {
    now (state) {
      const { serveTime, clientTime, nowTime } = state
      return serveTime + (nowTime - clientTime)
    }
  },
  mutations: {
    setNowTime (state, nowTime) {
      state.nowTime = nowTime
    }
  },
  actions: {
    run ({state, commit}) {
      if (state.run) return false
      state.run = true
      setInterval(() => {
        commit('setNowTime', Date.now())
      }, 500);
    }
  }
}

export default store